(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const ageGateModal = document.getElementById('age-gate-modal');
    if (!ageGateModal) return;

    const delay = parseInt(ageGateModal.dataset.delay || '10', 10) * 1000;
    const hasVerified = sessionStorage.getItem('age-verified');

    // Don't show if already verified in this session
    if (hasVerified) return;

    // Open modal after delay
    setTimeout(() => {
      ageGateModal.querySelector('dialog')?.showModal();
    }, delay);

    // Store verification when confirmed
    ageGateModal.querySelector('.age-gate-modal__button[on\\:click]')?.addEventListener('click', () => {
      sessionStorage.setItem('age-verified', 'true');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
